
webpack.register(
    'modules/course-statistics/course-statistics',
    function() {
        return import('modules/course-statistics/course-statistics');
    },
    true
);